import { cva, type VariantProps } from 'class-variance-authority';
import { LoaderCircle } from 'lucide-react';
import type { ButtonHTMLAttributes, Ref } from 'react';
import { cn } from '../../lib/cn';

const estilos = cva(
  'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60',
  {
    variants: {
      variante: {
        primario: 'bg-primaria text-primaria-texto hover:bg-primaria-hover',
        contorno: 'border border-borda bg-superficie text-texto hover:bg-superficie-2',
        fantasma: 'text-texto hover:bg-superficie-2',
        perigo: 'bg-perigo text-white hover:opacity-90',
      },
      tamanho: {
        normal: 'h-11 px-5 text-sm', // 44 px de altura: alvo de toque confortável
        pequeno: 'h-9 px-3 text-sm',
        icone: 'h-11 w-11',
      },
    },
    defaultVariants: { variante: 'primario', tamanho: 'normal' },
  },
);

export interface BotaoProps
  extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof estilos> {
  carregando?: boolean;
  /** React 19: a ref chega como prop e vai para o <button> (ex.: devolver o foco). */
  ref?: Ref<HTMLButtonElement>;
}

export function Botao({
  className,
  variante,
  tamanho,
  carregando = false,
  disabled,
  children,
  type = 'button',
  ...props
}: BotaoProps) {
  return (
    <button
      type={type}
      className={cn(estilos({ variante, tamanho }), className)}
      disabled={disabled || carregando}
      aria-busy={carregando || undefined}
      {...props}
    >
      {carregando && <LoaderCircle className="size-4 animate-spin" aria-hidden="true" />}
      {children}
    </button>
  );
}
